export default __webpack_public_path__ + "static/RxJava-d3fb8a2ee78211e24b962c72a37223ea.png";